module.exports = __webpack_public_path__ + "assets/bcf9f8414c22496e468b1152e705c4a4.mp3";